import { render } from "./CardRoleList.vue?vue&type=template&id=03d084e3"
import script from "./CardRoleList.vue?vue&type=script&lang=js"
export * from "./CardRoleList.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\TAfolabi\\Documents\\Projects\\legacy\\partner\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__